var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "pram",
          attrs: { model: _vm.pram, "label-width": "110px" },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: "租户id",
                prop: "id",
                rules: [
                  {
                    required: true,
                    message: "请填写租户id",
                    trigger: ["blur", "change"],
                  },
                ],
              },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "租户id", disabled: _vm.isCreate != 0 },
                model: {
                  value: _vm.pram.id,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "id", $$v)
                  },
                  expression: "pram.id",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "租户名称",
                prop: "name",
                rules: [
                  {
                    required: true,
                    message: "请填写租户名称",
                    trigger: ["blur", "change"],
                  },
                ],
              },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "租户名称" },
                model: {
                  value: _vm.pram.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "name", $$v)
                  },
                  expression: "pram.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "租户编码",
                prop: "code",
                rules: [
                  {
                    required: true,
                    message: "请填写租户编码",
                    trigger: ["blur", "change"],
                  },
                ],
              },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "租户编码" },
                model: {
                  value: _vm.pram.code,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "code", $$v)
                  },
                  expression: "pram.code",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isCreate !== 1
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: "管理员账号",
                    prop: "adminAccount",
                    rules: [
                      {
                        required: true,
                        message: "请填写管理员账号",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "管理员账号" },
                    model: {
                      value: _vm.pram.adminAccount,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "adminAccount", $$v)
                      },
                      expression: "pram.adminAccount",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isCreate !== 1
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: "管理员密码",
                    prop: "adminPassword",
                    rules: [
                      {
                        required: true,
                        message: "请填写管理员密码",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "管理员密码" },
                    model: {
                      value: _vm.pram.adminPassword,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "adminPassword", $$v)
                      },
                      expression: "pram.adminPassword",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "管理员身份",
                prop: "packages",
                rules: [
                  {
                    required: true,
                    message: "请选择套餐",
                    trigger: ["blur", "change"],
                  },
                ],
              },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "身份", clearable: "", multiple: "" },
                  model: {
                    value: _vm.pram.packages,
                    callback: function ($$v) {
                      _vm.$set(_vm.pram, "packages", $$v)
                    },
                    expression: "pram.packages",
                  },
                },
                _vm._l(_vm.packageList.list, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "发布类型", prop: "publishTypeList" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: "请选择发布类型",
                    multiple: "",
                    clearable: "",
                  },
                  model: {
                    value: _vm.pram.publishTypeList,
                    callback: function ($$v) {
                      _vm.$set(_vm.pram, "publishTypeList", $$v)
                    },
                    expression: "pram.publishTypeList",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "H5", value: "h5" } }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: { label: "小程序", value: "miniapp" },
                  }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "PC", value: "pc" } }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.pram.publishTypeList.includes("pc")
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: "PC网址",
                    prop: "websiteDomain",
                    rules: [
                      {
                        required: true,
                        message: "请填写PC网址",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "例如 https://www.example.com（无尾斜杠）",
                    },
                    model: {
                      value: _vm.pram.websiteDomain,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "websiteDomain", $$v)
                      },
                      expression: "pram.websiteDomain",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.pram.publishTypeList.includes("h5")
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: "H5网址",
                    prop: "h5Domain",
                    rules: [
                      {
                        required: true,
                        message: "请填写H5网址",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "例如 https://h5.example.com（无尾斜杠）",
                    },
                    model: {
                      value: _vm.pram.h5Domain,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "h5Domain", $$v)
                      },
                      expression: "pram.h5Domain",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "状态" } },
            [
              _c("el-switch", {
                attrs: { "active-value": true, "inactive-value": false },
                model: {
                  value: _vm.pram.status,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "status", $$v)
                  },
                  expression: "pram.status",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: [
                        "admin:system:role:update",
                        "admin:system:role:save",
                      ],
                      expression:
                        "['admin:system:role:update','admin:system:role:save']",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handlerSubmit("pram")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.isCreate === 0 ? "確定" : "更新"))]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }